'use client';

import { ILazyModules } from '@websolutespa/bom-mixer-models';
import React from 'react';
import { createGenericContext } from '../useGenericContext/useGenericContext';

export type ILazyModulesContext = ILazyModules;

const [useLazyModules, LazyModulesContextProvider] = createGenericContext<ILazyModulesContext>({});

function LazyModulesProvider({ children, modules }: { children?: React.ReactNode, modules?: ILazyModules }) {
  return (
    <LazyModulesContextProvider value={modules}>
      {children}
    </LazyModulesContextProvider>
  );
}

export { LazyModulesProvider, useLazyModules };

